"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIZFreight = void 0;
exports.WIZFreight = {
    id: 'WIZFreight',
    companyName: 'WIZ Freight',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'WIZFreight',
    },
    isInternal: false,
    isActive: true,
    countries: ['IN'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV0laRnJlaWdodC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9XSVpGcmVpZ2h0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsVUFBVSxHQUFVO0lBQzdCLEVBQUUsRUFBRSxZQUFZO0lBQ2hCLFdBQVcsRUFBRSxhQUFhO0lBQzFCLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLFlBQVk7S0FDdEI7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=